import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';
import { useEffect, useState } from 'react';

interface Props {
  fiMain: string; // 금융기관 대분류
  setFiMain: (v: string) => void;
  fiSub: string; // 금융기관 소분류
  setFiSub: (v: string) => void;
  onClose: () => void;
}

const list = [
  {
    category: '시중은행',
    details: [
      '신한은행',
      '우리은행',
      'SC제일은행',
      'KEB하나은행',
      '씨티은행',
      '국민은행',
      '아이엠뱅크',
    ],
  },
  {
    category: '지방은행',
    details: ['부산은행', '광주은행', '제주은행', '전북은행', '경남은행'],
  },
  {
    category: '인터넷은행',
    details: ['케이뱅크', '카카오뱅크', '토스뱅크'],
  },
  {
    category: '특수은행',
    details: ['산업은행', '기업은행', '농협은행', '수협은행', '수출입은행'],
  },
  {
    category: '증권사',
    details: [],
  },
  {
    category: '보험사',
    details: ['생명보험사 전체', '손해보험사 전체'],
  },
  {
    category: '저축은행',
    details: [],
  },
  {
    category: '상호금융',
    details: ['단위농축협', '단위수협', '신협', '산립조합', '새마을금고'],
  },
  {
    category: '여전사',
    details: ['신용카드사 전체', '리스할부금융사 전체', '신기술금융사 전체'],
  },
  {
    category: '신탁사',
    details: [],
  },
  {
    category: '대부업체',
    details: [],
  },
  {
    category: '유동화전문유한회사',
    details: [],
  },
  {
    category: '온라인투자연계금융업',
    details: [],
  },
  {
    category: '범농협',
    details: [
      '농협은행',
      '농협자산관리',
      '농협경제지주',
      '농협생명보험',
      '농협중앙회',
      '엔에이치농협캐피탈',
      '단위농축협',
    ],
  },
  {
    category: '범새마을금고',
    details: ['새마을금고', '새마을금고중앙회', '엠씨아이대부'],
  },
  {
    category: '범수협',
    details: ['수협은행', '단위수협', '수협중앙회'],
  },
];

const normalizeFiSubValue = (value: string) =>
  value === '금융기관 전체' ? '' : value;

function FinanceModal({ fiMain, setFiMain, fiSub, setFiSub, onClose }: Props) {
  const [localFiMain, setLocalFiMain] = useState(fiMain);
  const [localFiSub, setLocalFiSub] = useState(normalizeFiSubValue(fiSub));
  const [openOptionList, setOpenOptionList] = useState<string[]>(
    fiMain ? [fiMain] : []
  );

  useEffect(() => {
    setLocalFiMain(fiMain);
    setLocalFiSub(normalizeFiSubValue(fiSub));
    setOpenOptionList(fiMain ? [fiMain] : []);
  }, [fiMain, fiSub]);

  const handleConfirm = () => {
    if (localFiMain === '' && localFiSub === '') {
      setFiSub('금융기관 전체');
    } else if (localFiMain && localFiSub === '') {
      setFiSub(`${localFiMain} 전체`);
    } else {
      setFiSub(localFiSub);
    }

    setFiMain(localFiMain);
    onClose();
  };

  const toggleCategory = (r: string) => {
    if (openOptionList.includes(r)) {
      setOpenOptionList(openOptionList.filter((i) => i !== r));
    } else {
      setOpenOptionList([...openOptionList, r]);
    }
  };

  const handleDetailItemClick = (category: string, item: string) => {
    setLocalFiMain(category);
    if (item === '전체') {
      setLocalFiSub('');
    } else {
      setLocalFiSub(item);
    }
  };

  return (
    <BottomModal onClose={onClose}>
      <Header>금융 기관 선택</Header>
      <Content>
        <Item
          onClick={() => {
            setLocalFiMain('');
            setLocalFiSub('');
          }}
        >
          <ItemLabel
            $active={
              localFiMain === '' &&
              (localFiSub === '' || localFiSub === '금융기관 전체')
            }
          >
            전체
          </ItemLabel>
          {localFiMain === '' &&
            (localFiSub === '' || localFiSub === '금융기관 전체') && (
            <img src="/assets/images/check/npl-blue-check.svg" alt="active" />
          )}
        </Item>
        {list.map(({ category, details }) => (
          <>
            <DropdownRegion
              key={category}
              onClick={() => toggleCategory(category)}
            >
              <DropdownRegionLabel>{category}</DropdownRegionLabel>
              <DropdownArrow
                src="/assets/images/arrow/arrow-right-tertiary.svg"
                alt=""
                $open={openOptionList.includes(category)}
              />
            </DropdownRegion>
            {openOptionList.includes(category) && (
              <>
                <Item onClick={() => handleDetailItemClick(category, '전체')}>
                  <ItemLabel
                    $active={
                      localFiMain === category &&
                      (localFiSub === '' || localFiSub === '전체')
                    }
                  >
                    {category} 전체
                  </ItemLabel>
                  {localFiMain === category &&
                    (localFiSub === '' || localFiSub === '전체') && (
                      <img
                        src="/assets/images/check/npl-blue-check.svg"
                        alt="active"
                      />
                    )}
                </Item>

                {details.map((c) => (
                  <Item
                    key={c}
                    onClick={() => handleDetailItemClick(category, c)}
                  >
                    <ItemLabel $active={localFiSub === c}>{c}</ItemLabel>
                    {localFiSub === c && (
                      <img
                        src="/assets/images/check/npl-blue-check.svg"
                        alt="active"
                      />
                    )}
                  </Item>
                ))}
              </>
            )}
          </>
        ))}
      </Content>
      <Bottom>
        <CancleButton onClick={onClose}>취소</CancleButton>
        <ConfirmButton onClick={handleConfirm}>적용</ConfirmButton>
      </Bottom>
    </BottomModal>
  );
}

export default FinanceModal;

const Header = styled.div`
  display: flex;
  padding: 24px 20px 8px 20px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  color: #0c0e12;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.36px;
`;

const TabContainer = styled.div`
  display: flex;
  padding: 8px 20px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const Tab = styled.div<{ $active?: boolean }>`
  display: flex;
  height: 36px;
  padding: 0 14px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e8e9ed;
  background: #fff;
  color: #424854;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.26px;

  ${({ $active }) =>
    $active &&
    `
  background: #272C36;
  color: #F4F5F7;
  border-color: transparent;
`}
`;

const Content = styled.div`
  display: flex;
  height: 100%;
  padding: 8px 20px 24px 20px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  overflow-y: auto;
`;

const Item = styled.div`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const ItemLabel = styled.div<{ $active?: boolean }>`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  color: ${({ $active }) => ($active ? '#0c0e12' : '#787D87')};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;

const DropdownRegion = styled.div`
  display: flex;
  padding: 4px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: #f4f5f7;
`;

const DropdownArrow = styled.img<{ $open?: boolean }>`
  width: 20px;
  height: 20px;
  transform: ${({ $open }) => ($open ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;

const DropdownRegionLabel = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  flex: 1 0 0;
  color: #424854;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;

const Bottom = styled.div`
  display: flex;
  align-self: stretch;
  padding: 16px 24px 24px 24px;
  align-items: center;
  gap: 8px;
`;

const Button = styled.button`
  border: none;
  outline: none;

  display: flex;
  height: 44px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.3px;
`;

const CancleButton = styled(Button)`
  background: #f4f5f7;
  color: #424854;
`;

const ConfirmButton = styled(Button)`
  background: #3f6ef1;
  color: rgba(244, 245, 247, 0.88);
  flex: 1 0 0;
`;
